import { useEffect, useState, useRef } from 'react';
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Stack,
  Text,
  useDisclosure,
  Image,
  Container,
  Spacer,
  Modal, 
  ModalOverlay, 
  ModalContent, 
  ModalBody, 
} from '@chakra-ui/react';

import PropTypes from "prop-types"

import { ModuleBoxDrawer } from '../Structural/ModuleBoxDrawer.jsx';
import { Divider } from '../Divider.jsx';

import { getSignedURLFromS3File } from '../graphqlCompnents/AWS/S3/getSignedURLFromS3File.jsx';
import { fetchUploadedDocument } from '../graphqlCompnents/AWS/S3/fetchUploadedDocument.jsx';
import { fetchUploadedReceipts } from '../graphqlCompnents/AWS/S3/fetchUploadedReceipts.jsx';
import { fetchDivisionOptions } from '../graphqlCompnents/Statement/fetchDivisionOptions.jsx';
import { fetchTeamMemberByAccountNumber } from '../graphqlCompnents/Statement/fetchTeamMemberByAccountNumber.jsx';
import { fetchClientsForAllDivisions } from '../graphqlCompnents/DJT/fetchClientsForAllDivisions.jsx';
import { fetchContactCompaniesByDivision } from '../graphqlCompnents/DJT/fetchContactCompaniesByDivision.jsx';
import { fetchAllUnits } from '../graphqlCompnents/Unit/fetchAllUnits.jsx';

import { formatCurrency, stripToNumbersAndDot  } from '../functions/currency.jsx';

import { FormSelectSimple } from '../Form/Select/FormSelectSimple.jsx';
import { TextareaInput } from '../Form/Input/TextareaInput.jsx';
import { TextInput } from '../Form/Input/TextInput.jsx';

import { ButtonSecondaryPlain } from '../Form/Button/ButtonSecondaryPlain.jsx';
import { ButtonPrimaryPlain } from '../Form/Button/ButtonPrimaryPlain.jsx';
import { ButtonQuaternaryWithIcon } from '../Form/Button/ButtonQuaternaryWithIcon.jsx';

import { VendorMap } from './VendorMap.jsx';

import { stateOptions } from '../Form/Select/stateOptions.jsx';

import { GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
import * as pdfjsLib from 'pdfjs-dist';

import { isValidDate } from '../functions/dateTime.jsx';


const statementTypeOptions = [
    { value: '', label: '-- Select Statement Type --' },
    { value: 'receipt', label: 'Receipt' },
    // { value: 'credit-note', label: 'Credit Note' },
    { value: 'refund', label: 'Credit Card Refund' },
    { value: 'credit', label: 'Vendor Credit Note' },
    { value: 'invoice', label: 'Invoice' },
  ];

export const EditTransaction = (props) => {
  const renderCount = useRef(0);
  renderCount.current += 1;
  console.log('🔢 EditTransaction render:', renderCount.current);
  const {
    transaction={},
    onClose=()=>{},
    environment="sandbox",
    expenseCategories=[],
    selectedExpenseCategory={},
    qbVendors=[],
    handleMapVendor=()=>{},
    register=()=>{},
    control={},
    errors={},
    setError=()=>{},
    clearErrors=()=>{},
    setValue=()=>{},
    updateExpenseCategory=()=>{},
    rowIndex='',
    updateReceipt=()=>{},
    handleSubmit=()=>{},
    adminName = '',
    handleDetachReceipt=()=>{},
    onDocumentsFetched=()=>{},
  } = props;

  // vendorName: "napa auto parts goods"
  // if on load type = invoice and name contains napa set vendor to NAPA Dallas Porta;

  console.log('EditTransaction props: ', transaction);

  useEffect(() => {
    // This runs once when component mounts
    if (props.transaction?.matchedItem?.id) {
      console.log('🚀 Setting plaidCreditCardTransactionId on mount:', props.transaction.matchedItem.id);
      setValue('plaidCreditCardTransactionId', props.transaction.matchedItem.id);
    }
  }, [props.transaction?.matchedItem?.id, setValue]);


  const { isOpen: isModalOpen, onOpen: onModalOpen, onClose: onModalClose } = useDisclosure(); // For controlling modal state
  const [currentImage, setCurrentImage] = useState(null); // To hold the image URL to display

  const [ enteredDueDate, setEnteredDueDate ] = useState('')
  useEffect(() => {
    const timeOutId = setTimeout(() => handleDueDateChanged(enteredDueDate), 750);
    return () => clearTimeout(timeOutId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[enteredDueDate])

  const handleDueDateChanged = async (enteredDate) => {
    if (enteredDate.length===10) {
      if (isValidDate(enteredDate)) {
        setValue('dueDate', enteredDate);
        console.log('Entered date is valid: ', enteredDate);
      }
    }
  }

  const [ enteredPurchaseDate, setEnteredPurchaseDate ] = useState('')
  useEffect(() => {
    const timeOutId = setTimeout(() => handleDateChanged(enteredPurchaseDate), 750);
    return () => clearTimeout(timeOutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[enteredPurchaseDate])

  const handleDateChanged = async (enteredDate) => {
    if (enteredDate.length===10) {
      const validDate = isDateValid(enteredDate);
      if (!validDate.isValid) {
        setError('transactionDate', {
          type: 'manual',
          message: validDate.message
        });
      } else {
        setValue('transactionDate', enteredDate);
        clearErrors('transactionDate');
      }
    }
  }

  const isDateValid = (inputDate) => {
    let year, month, day;
  
    if (/^\d{4}-\d{2}-\d{2}$/.test(inputDate)) {
      // Matches YYYY-MM-DD (e.g., "2025-03-12")
      [year, month, day] = inputDate.split("-").map(Number);
    } else if (/^(0[1-9]|1[0-2])[/](0[1-9]|[12][0-9]|3[01])[/]\d{4}$/.test(inputDate)) {
      // Matches MM/DD/YYYY (e.g., "03/12/2025")
      [month, day, year] = inputDate.split("/").map(Number);
    } else {
      return { isValid: false, message: "Invalid date format. Use MM/DD/YYYY or YYYY-MM-DD." };
    }
  
    // Validate real date (e.g., prevent "02/30/2025")
    const enteredDate = new Date(year, month - 1, day);
    if (
      enteredDate.getFullYear() !== year ||
      enteredDate.getMonth() + 1 !== month ||
      enteredDate.getDate() !== day
    ) {
      return { isValid: false, message: "Invalid calendar date." };
    }
  
    // Get the current date (without time)
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    // Get the date 3 months ago
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    threeMonthsAgo.setHours(0, 0, 0, 0);
  
    // Ensure the date is within the last 3 months AND not in the future
    if (enteredDate < threeMonthsAgo) {
      return { isValid: false, message: "Date must be within the last 3 months." };
    }
  
    if (enteredDate > today) {
      return { isValid: false, message: "Date is required and cannot be in the future." };
    }
  
    return { isValid: true };
  };

  const handleImageClick = (imageUrl) => {
    setCurrentImage(imageUrl);  // Set the clicked image URL
    onModalOpen();  // Open the modal to show the image
  };

  const [ isSubmitting, setIsSubmitting ] = useState(false);
  
  // console.log('transaction: ', transaction?.capitalOneInstantNotification?.status);
  // console.log('qbVendors: ', qbVendors);

  const allSort = (environment==="sandbox") ? "sandbox" : "all";

  // ----- EDIT TRANSACTION DRAWER -----
  // const { isOpen: isEditTransactionVendorOpen , onOpen: onEditTransactionVendorOpen, onClose: editTransactionVendorClose } = useDisclosure()

  // Local state to determine if VendorMap should be shown
  // This should be based on actual vendor matching status, not a persisted flag
  const [shouldShowVendorMap, setShouldShowVendorMap] = useState(false);

  // Single source of truth for the vendor chosen during THIS edit session.
  // Set synchronously when the admin picks a vendor, so the confirmation UI and
  // the map-visibility never depend on the (unreliably-timed) mutated transaction
  // prop. { id, name } or null.
  const [assignedVendor, setAssignedVendor] = useState(null);

  const [ iftaGallons, setIftaGallons ] = useState('');
  const [ iftaOdometer, setIftaOdometer ] = useState('');
  // const [ iftaState, setIftaState ] = useState({ value: ' ', label: '-- Select State --' });
  const [ iftaState, setIftaState ] = useState(null);

  const issueIsResolved = transaction?.matchStatus === 'fixed-issue';
  const [ isUpdating, setIsUpdating ] = useState(false);
  console.log('isUpdating: ', isUpdating);
  // const [ isPublishing, setIsPublishing ] = useState(false);
  
  // Wrapper for handleMapVendor that also updates local VendorMap visibility
  const handleMapVendorWrapper = (vendor, index) => {
    console.log('🗺️ Vendor mapped:', vendor);
    // Call the parent's handleMapVendor
    handleMapVendor(vendor, index);
    // Record the selection locally (synchronous, reliable) and hide the map.
    if (vendor?.id) {
      setAssignedVendor({ id: vendor.id, name: vendor.name || '' });
      setShouldShowVendorMap(false);
    }
  };
  
  // Initialize vendor selection state ONLY when a new receipt is opened
  // (keyed on transaction.id). Deliberately NOT keyed on qbSupplierMatched /
  // qbVendor.qbId: those values mutate during selection, and depending on them
  // here caused this effect to re-run mid-selection and flip shouldShowVendorMap
  // back to true — clobbering the admin's pick and re-showing the search box with
  // no feedback. Selection now drives state through handleMapVendorWrapper.
  useEffect(() => {
    const hasInitialVendor =
      !!transaction?.qbSupplierMatched && !!transaction?.qbVendor?.qbId;

    setAssignedVendor(
      hasInitialVendor
        ? {
            id: transaction.qbVendor.qbId,
            name: transaction.qbVendor.qbDisplayName || transaction?.qbSupplierName || '',
          }
        : null
    );
    setShouldShowVendorMap(!hasInitialVendor);

    // Reset showEditSupplier for each new transaction so that state from
    // handleOnClose (return-to-cardholder flow) never persists into the next
    // receipt when the drawer keeps EditTransaction mounted between opens.
    setShowEditSupplier(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction?.id]);
  
  useEffect(() => {
    // Set the workerSrc to the file in the public folder
    GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
    setValue('publish', 'true');
    setValue('matchStatus', 'published');
    setValue('id', transaction?.id);
    console.log('selectedExpenseCategory: ', selectedExpenseCategory)
  }, []);
  const hasInitializedExpenseCategory = useRef(false);

  // const [ expenseCategoryLocked, setExpenseCategoryLocked ] = useState(false);
  
  useEffect(() => {
    console.log('💰 Expense category useEffect running. Flag:', hasInitializedExpenseCategory.current);
    
    const getExpenseCategory = (id) => {
      // if (!expenseCategories.length) return '';
      // Find the expense that matches the given qbId
      const expense = expenseCategories.find((category) => category.value === id);
  
      // If no expense is found, return null or a default value
      if (!expense) return '';
  
      // Return the formatted object based on the found expense
      const expenseCategory = {
        value: expense.value,
        label: expense.label,
        isIFTATracked: expense?.isIFTATracked === true ? true : false,
      };

      console.log('expenseCategory: ', expenseCategory);  

      // if (expenseCategory.isIFTATracked) {
      //   setExpenseCategoryLocked(true);
      // }
      
      setValue('expenseCategoryLabel', expenseCategory?.label||'');

      hasInitializedExpenseCategory.current = true;
      console.log('✅ Expense category initialized');
      // TEMPORARY FIX: Removed call to updateExpenseCategory to stop infinite loop
      // This was causing parent re-renders which triggered child re-renders
      // Need to find alternative approach for syncing expense category to parent
      console.log('🔄 Would update expense category for transaction:', transaction?.id);
      
    };

    if (transaction?.expenseCategoryId && expenseCategories.length && transaction?.id && !hasInitializedExpenseCategory.current) {
      console.log('💚 Initializing expense category...');
      getExpenseCategory(transaction?.expenseCategoryId);
    } else {
      console.log('⏭️ Skipping expense category - already initialized or missing data');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[expenseCategories, transaction?.id, transaction?.expenseCategoryId, setValue])

  const [selectedIFTAUnitOption, setSelectedIFTAUnitOption] = useState('');
  // Reset expense category flag when transaction ID changes
  useEffect(() => {
    hasInitializedExpenseCategory.current = false;
  }, [transaction?.id])
  const [ unitOptions, setUnitOptions] = useState([])
  const [ iftaUnitOptions, setIFTAUnitOptions ] = useState([])
  useEffect(() => {
    const fetchAndSetUnits = async () => {
      try {
        const units = await fetchAllUnits();
        // console.log('allUnits: ', units)
        units.sort((a, b) => a.codeSortable.localeCompare(b.codeSortable));

        // create IFTA unit options
        const iftaUnits = units.filter(unit => unit.irpiftaRegistered === true && unit.isActive === true);
        // console.log('iftaUnits: ', iftaUnits)
        const iftaUnitOptions = iftaUnits.map(unit => ({
          value: unit.id,
          label: `${unit.code} - ${unit.type.name} / ${unit.subType.name}`
        }));

        setIFTAUnitOptions(iftaUnitOptions)

        // reduce down to active units
        const activeUnits = units.filter(unit => unit.isActive === true);
        // Create unitOptions
        const options = activeUnits.map(unit => ({
          value: unit.id,
          label: `${unit.code} - ${unit.type.name} / ${unit.subType.name}`
        }));
        // console.warn('unitOptions: ', options)
        setUnitOptions(options)

      } catch (error) {
        console.error('Failed to fetch units:', error);
      }
    };

    fetchAndSetUnits();
  }, []); 

  const [ selectedStatementType, setSelectedStatementType ] = useState('');
  const hasInitializedStatementType = useRef(false);

  const updateSelectedStatementType = (event) => {
    console.log(' 🐞  updateSelectedStatementType event: ', event)
    setSelectedStatementType(event);
    setValue('selectStatementType', event.value)
  };

  useEffect(() => {
    console.log('📊 Statement type useEffect running. Flag:', hasInitializedStatementType.current);
    if (transaction?.transactionType && statementTypeOptions?.length>0 && !hasInitializedStatementType.current) {
      console.log(' 🐞  transaction.transactionType: ', transaction.transactionType);
      const statementType = statementTypeOptions.find(option => option.value === transaction.transactionType);
      console.log(' 🐞  statementType: ', statementType);
      console.log(' 🐞  statementTypeOptions: ', statementTypeOptions);
      console.log(' 🐞  statementTypeOptions.length: ', statementTypeOptions.length);
      
      if (statementType) {  // Check FIRST
        console.log(' 🐞  statementType.value: ', statementType.value); // Then log
        setSelectedStatementType(statementType);
        setValue('selectStatementType', statementType.value)
        hasInitializedStatementType.current = true;
        console.log('✅ Statement type initialized');
      } else {
        console.warn(' ⚠️  No matching statementType found for:', transaction.transactionType);
      }
    } else {
      console.log('⏭️ Skipping statement type - already initialized or missing data');
    }
  },[transaction?.transactionType, transaction?.id, statementTypeOptions, setValue])

  // Reset when transaction ID changes
  useEffect(() => {
    hasInitializedStatementType.current = false;
  }, [transaction?.id])
  
  const [ teamMemberName, setTeamMemberName ] = useState(null);
  useEffect(() => {
    const fetchTeamMember = async () => {
      try {
        const results = await fetchTeamMemberByAccountNumber(transaction?.matchedItem?.accountNumber);
        // console.info('Fetched team member:', results);
        let teamMember = {};
        if (results?.length>1) {
          teamMember = results.find((result) => result?.allSort === allSort);
        } else {
          teamMember = results[0]
        }
        
        const teamMemberDivision = teamMember?.teamMember?.division?.prettyname;
        let firstName = '';
        let lastName = '';
        if (teamMember) {
          const name = teamMember?.teamMember;
          firstName = name.goesBy||name.firstName||'';
          lastName = name.lastName||'';
        }
        setTeamMemberName(`${firstName} ${lastName}-${teamMemberDivision}`);
      } catch (error) {
        console.error('Error in fetching team member:', error);
      }
    };
  
    if (transaction?.matchedItem?.accountNumber?.length===4) {
      fetchTeamMember();
    } else if (transaction?.teamMember) {
      const name = transaction?.teamMember;
      const firstName = name.goesBy||name.firstName||'';
      const lastName = name.lastName||'';
      const division = transaction?.teamMember?.division?.prettyname;
      setTeamMemberName(`${firstName} ${lastName}-${division}`);
    }
  },[allSort, environment, transaction])

  // const [ receiptSignedUrl, setReceiptSignedUrl ] = useState(null);
  useEffect(() => {
    const fetchSignedUrl = async (documentId) => {
      try {
        const document = await fetchUploadedDocument(documentId);
        // console.log('Fetched document: ', document);
        
        // Check for valid document structure
        if (!document?.bucket || !document?.key) {
          throw new Error(`Invalid document structure: ${JSON.stringify(document)}`);
        }
  
        // const signedURL = await getSignedURLFromS3File(document);
        // console.log('Generated Signed URL: ', signedURL);
        // setReceiptSignedUrl(signedURL);
      } catch (error) {
        console.error('Error in fetching or generating signed URL:', error);
      }
    };
  
    if (transaction?.uploadedDocumentId) {
      fetchSignedUrl(transaction.uploadedDocumentId);
    }
  }, [transaction]);

  const [ previewImages, setPreviewImages ] = useState([]);
  const [ receiptSignedUrls, setReceiptSignedUrls ] = useState([]);

  useEffect(() => {
    const fetchReceipts = async () => {
      try {
        const receipts = await fetchUploadedReceipts(transaction?.id);
        console.log('Fetched receipts:', receipts);
  
        // Check if receipts is an array
        if (!Array.isArray(receipts)) {
          throw new Error('Invalid receipts format.');
        }
  
        // Fetch all signed URLs and generate previews for each receipt
        const signedUrls = await Promise.all(
          receipts.map(async (receipt) => {
            // console.log(`Receipt ${index + 1}:`, receipt);
  
            const uploadedDocument = receipt?.uploadedDocument;
  
            // Check for valid document structure
            if (!uploadedDocument?.bucket || !uploadedDocument?.key) {
              throw new Error(`Invalid document structure: ${JSON.stringify(receipt)}`);
            }
  
            // Fetch the signed URL using the `uploadedDocument` details
            const signedURL = await getSignedURLFromS3File({
              bucket: uploadedDocument.bucket,
              key: uploadedDocument.key,
              identityId: uploadedDocument.identityId
            });
  
            // Generate a preview for the file (either an image or a PDF)
            const preview = await generatePreview(signedURL, uploadedDocument.key);  // Generate preview
  
            // Return both the signed URL and its corresponding preview
            return { signedURL, preview };
          })
        );

        const documents = receipts.map(r => r.uploadedDocument).filter(Boolean);
        onDocumentsFetched(documents);
  
        // Separate signed URLs and previews into their own arrays
        const urls = signedUrls.map(item => item.signedURL);
        const previews = signedUrls.map(item => item.preview);
  
        // Set the state with both signed URLs and previews
        setReceiptSignedUrls(urls);
        setPreviewImages(previews);  // use this to display previews
  
      } catch (error) {
        console.error('Error in fetching receipts:', error);
      }
    };
  
    if (transaction) {
      fetchReceipts();
    }
  
  }, [transaction]);
  
  // generatePreview function
  const generatePreview = async (signedURL, key) => {
    const fileType = key?.split('.').pop();  // Extract the file type from the file key
  
    if (fileType === 'pdf') {
      return await generatePdfPreview(signedURL);
    } else if (['jpg', 'jpeg', 'png'].includes(fileType.toLowerCase())) {
      return signedURL;  // For image files, the signed URL can directly be used as the preview
    } else {
      throw new Error('Unsupported file type for preview generation');
    }
  };
  
  // generatePdfPreview function
  const generatePdfPreview = async (pdfUrl) => {
    const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
    const page = await pdf.getPage(1);
  
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const viewport = page.getViewport({ scale: 1.0 });
  
    canvas.height = viewport.height;
    canvas.width = viewport.width;
  
    await page.render({ canvasContext: context, viewport }).promise;
    
    return canvas.toDataURL();  // Return the preview as a data URL
  };

  const handleKeyDown = (event) => {
    // Check if the key pressed is 'Enter'
    if (event.key === 'Enter' && event.target.type !== 'textarea') {
      event.preventDefault();  // Prevent form submission
    }
  };

  const [ showHasIssueForm, setShowHasIssueForm ] = useState(false);
  const handleReceiptHasIssue = () => {
    console.log('Receipt has issue');
    setShowHasIssueForm(prevState => !prevState);
  }

  const getStateOptions = (stateAbbreviation) => {
    if (!stateAbbreviation) return '';
    const state = stateOptions.find(option => option.value === stateAbbreviation);
    return state.label;
  }

  // const updateSelectedQuickBooksVendor = (event) => {
  //   console.log('event: ', event)
  //   setSelectedQuickBooksVendorOption(event);
  //   setValue('selectQuickBooksVendor', event.value)
  //   clearErrors('selectQuickBooksVendor')
  // }

  // const [ currentEditTransaction, setCurrentEditTransaction ] = useState(null)
  // const handleOpenEditTransactionVendor = (transaction) => {
  //   console.log('transaction: ', transaction)
  //   setCurrentEditTransaction(transaction)
  // }

  // useEffect(() => {
  //   currentEditTransaction && onEditTransactionVendorOpen();
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[currentEditTransaction])

  // const onEditTransactionVendorClose = () => {
  //   setCurrentEditTransaction(null)
  //   // handleRefresh()
  //   editTransactionVendorClose()
  // }

  const [ showEditSupplier, setShowEditSupplier ] = useState(true);
  // function to toggle the showEditSupplier off and on
  // const toggleShowEditSupplier = () => {
  //   setShowEditSupplier(prevState => !prevState);
  // }

  const [ receiptIssue, setReceiptIssue ] = useState('');
  // const [ receiptIssueLog, setReceiptIssueLog ] = useState(transaction?.issue||'');
  const receiptIssueLog = transaction?.issue || '';

  const handleUpdateReceiptIssue = (issue) => {
    // add admin name to the issue test with a colon and a hard return
    const issues = receiptIssueLog + adminName + ': ' + issue + '::cr::';
    setReceiptIssue(issues);
  }

  const handleReturnReceiptToCardholder = async () => {
    setIsUpdating(true);
    const props = {
      matchStatus: 'has-issue',
      id: transaction?.id,
      hasIssue: true,
      issue: receiptIssue,
      expenseCategoryId: selectedExpenseCategory?.value,
    }
    console.log('props: ', props);
    await updateReceipt(props);
    handleOnClose();
  }

  const handleOnClose = () => {
    setShowHasIssueForm(false);
    setShowEditSupplier(false);
    setValue('merchantName', '');
    setValue('newVendorName', '');
    setReceiptIssue('');
    setValue('transactionDate', '');
    clearErrors('transactionDate');
    setValue('amountDue', '');
    clearErrors('amountDue');
    setValue('dueDate', '');
    clearErrors('dueDate');
    setValue('invoiceReceiptNumber', '');
    clearErrors('invoiceReceiptNumber');

    setValue('receiptIssue', '');
    clearErrors('receiptIssue');
    // setCurrentEditTransaction(null);
    // setSelectedQuickBooksVendorOption(null);
    // setSelectedExpenseCategoryOption(null);

    setValue('selectExpenseCategory', '');
    setValue('selectQuickBooksVendor', '');

    setValue('selectStatementType', '');
    setValue('selectDivision', '');
    setValue('selectClient', '');
    setValue('clientQbId', '');

    setIFTAUnitOptions([]);
    setSelectedIFTAUnitOption(null);
    setValue('selectOTRUnit', '');
    setIftaGallons('');
    clearErrors('iftaGallons');
    setIftaOdometer('');
    clearErrors('iftaOdometer');
    setIftaState({ value: '', label: '-- Select State --' });
    clearErrors('iftaState');
    setValue('iftaTeamMemberId', '');
    setValue('iftaFuelTaxTrackId', '');

    setTeamMemberName(null);
    // setReceiptSignedUrl(null);
    setPreviewImages([]);
    setReceiptSignedUrls([]);
    setCurrentImage(null);
    setIsUpdating(false);
    onClose();
  }

  const [ selectedDivision, setSelectedDivision ] = useState('');
  const [ divisionOptions, setDivisionOptions ] = useState([])
  const [ allClientOptions, setAllClientOptions ] = useState([]);
  const [ clientOptions, setClientOptions ] = useState([]);
  const [ selectedClient, setSelectedClient ] = useState('');
  // const [ divisionIsLocked, setDivisionIsLocked ] = useState(false);
  const [ unitsAttached, setUnitsAttached ] = useState([]);
  // const [ unitNamesString, setUnitNamesString ] = useState([]);
  // const [ clientQbId, setClientQbId ] = useState('');

  // useEffect(() => {
  //   if (allClientOptions?.length>0) {
  //     let clientId = transaction.clientId||"";
  //     console.warn('clientId: ', clientId);
  //     const client = allClientOptions.find(
  //       option => option.value === clientId
  //     );
  //     console.warn('client: ', client);
  //     setSelectedClient(client || allClientOptions[0]);
  //     setValue('selectClient', clientId);
  //     setDivisionIsLocked(true);
  //     setClientQbId(client?.qbId||'');
  //     setValue('clientQbId', client?.qbId||'');
  //   }
  // },[transaction, allClientOptions, setValue])

  useEffect(() => {
    console.log('🎯 Client dropdown setup for transaction:', transaction?.id);
    console.log('  allClientOptions.length:', allClientOptions?.length);
    
    // Wait for both allClientOptions to load AND transaction to exist
    if (allClientOptions?.length > 0 && transaction?.id) {
      const clientId = transaction?.clientId || "";
      console.warn('  Setting up client for clientId:', clientId);
      
      const client = allClientOptions.find(
        option => option.value === clientId
      );
      console.warn('  Found client:', client?.label || 'none');
      
      // Set the selected client state
      setSelectedClient(client || allClientOptions[0]);
      setValue('selectClient', clientId);
      // setDivisionIsLocked(true);
      // setClientQbId(client?.qbId || '');
      setValue('clientQbId', client?.qbId || '');
      
      // CRITICAL FIX: Populate the clientOptions dropdown array
      if (client?.divisionId) {
        // If we have a client with a division, filter to show only that division's clients
        const filteredClients = allClientOptions.filter(
          (option) => option.divisionId === client.divisionId || option.value === ''
        );
        console.warn('  ✅ Setting clientOptions (filtered):', filteredClients.length, 'options');
        setClientOptions(filteredClients);
        
        // Also set the division dropdown to match
        const matchingDivision = divisionOptions.find(
          (div) => div.value === client.divisionId
        );
        if (matchingDivision) {
          setSelectedDivision(matchingDivision);
          setValue('selectDivision', matchingDivision);
        }
      } else {
        // No client selected or no division - show all clients
        console.warn('  ✅ Setting clientOptions (all):', allClientOptions.length, 'options');
        setClientOptions(allClientOptions);
      }
    } else {
      console.warn('  ⏳ Waiting for data:', {
        hasAllClientOptions: allClientOptions?.length > 0,
        hasTransaction: !!transaction?.id
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction?.id, transaction?.clientId, allClientOptions, divisionOptions, setValue]);
  
  const handleClientChange = (event) => {
    const match = allClientOptions.find(
      option => option.value === event.value
    );
    // console.warn('match: ', match?.qbId||'');
    // setClientQbId(match?.qbId||'');
    setValue('clientQbId', match?.qbId||'');
    setSelectedClient(event);
    setValue('selectClient', event.value);
  };

  useEffect(() => {
    // All clients
    const fetchAllClients = async () => {
      try {
        const response = await fetchClientsForAllDivisions();
        const clientOptions = response.map(client => ({
          value: client.value,
          label: client.label,
          divisionId: client.divisionId,
          qbId: client?.qbId||'',
        }));

        // Add the ' -- None --' option at the beginning
        clientOptions.unshift({ value: '', label: ' - None -' });

        console.warn('clientOptions: ', clientOptions);
      
        setAllClientOptions(clientOptions);
      } catch (error) {
        console.error('Failed to fetch clients:', error);
      }
    };

    fetchAllClients();

  },[])

  // fetch all divisions shared by all users
  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        const responseAll = await fetchDivisionOptions('all');
        const optionsAll = responseAll.map(division => ({
          value: division.id,
          label: division.prettyname,
        }));
  
        // Fetch divisions for 'special'
        const responseSpecial = await fetchDivisionOptions('special');
        const optionsSpecial = responseSpecial.map(division => ({
          value: division.id,
          label: division.prettyname,
        }));
  
        // Combine and sort options
        const combinedOptions = [...optionsAll, ...optionsSpecial].sort((a, b) => 
          a.label.localeCompare(b.label)
        );
        console.log('🐞 combinedOptions: ', combinedOptions);
        setDivisionOptions(combinedOptions);
  
      } catch (error) {
        console.error('Failed to fetch divisions:', error);
      }
    };
  
    fetchDivisions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleDivisionChange = (event) => {
  //   const divisionId = event.value;
  //   setSelectedDivision(event);
  //   // setValue('selectDivision', divisionId);
  //   setValue('selectDivision', event);
  //   clearErrors('selectDivision');

  //   const filteredClients = allClientOptions.filter(
  //     (client) => client.divisionId === divisionId
  //   );

  //   setClientOptions(filteredClients)
  //   setValue('selectClient', filteredClients);
  //   setSelectedClient('');
  //   setValue('selectClient', '');
  // };

  const handleDivisionChange = async (event) => {
    const divisionId = event.value;
    setSelectedDivision(event);
    setValue('selectDivision', event);
    clearErrors('selectDivision');
    
    // Clear current client selection
    setSelectedClient('');
    setValue('selectClient', '');
    
    // Fetch fresh clients for the selected division
    try {
      const response = await fetchContactCompaniesByDivision(divisionId);
      const clientOptions = response.map(client => ({
        value: client.value,
        label: client.label,
      }));
      
      // Add the ' -- None --' option at the beginning
      clientOptions.unshift({ value: '', label: ' - None -' });
      
      setClientOptions(clientOptions);
    } catch (error) {
      console.error('Failed to fetch clients:', error);
    }
  };
  
  const handleNewVendorName = (event) => {
    console.log('New vendor name: ', event);
    setUpdatedMerchantName(event);
    setValue('merchantName', event);
    clearErrors('merchantName');
    setValue('newVendorName', event);
    clearErrors('newVendorName');
  }

  const [ updatedMerchantName, setUpdatedMerchantName ] = useState('');
  const handleUpdateMerchant = (event) => {
    // DO NOT mutate transaction props - just update state and form values
    console.log('Updated merchant name: ', event);
    setUpdatedMerchantName(event);
    setValue('merchantName', event);
    clearErrors('merchantName');
  }

  useEffect(() => {
    if (transaction?.units?.items?.length>0) {

      const unitNames = transaction.units.items.map(
        (unit) => unit?.unit?.code
      ).filter(Boolean); // remove any undefined/null

      const unitNamesString = unitNames.join(', ');
      // setUnitNamesString(unitNamesString);
      setValue('unitNamesString', unitNamesString);
      console.log('unitNamesString: ', unitNamesString);

      const units = transaction.units.items.map((unit) => {
        console.log('unit: ', unit);
        return {
          unitName: `${unit?.unit?.code} - ${unit?.unit?.type?.name}/${unit?.unit?.subType?.name}`,
        };
      });
      console.log('units: ', units);
      setUnitsAttached(units);
    }
  },[transaction])

  useEffect(() => {
    // Division
    if (divisionOptions) {
      const division = divisionOptions.find(
        option => option.value === transaction.divisionId
      );
      setSelectedDivision(division || '');
      // setValue('selectDivision', transaction.divisionId);
      setValue('selectDivision', division);
    }

    // Clients by division
    const fetchClients = async (divisionId) => {
      if (divisionId) {
        try {
          const response = await fetchContactCompaniesByDivision(divisionId);
          const clientOptions = response.map(client => ({
            value: client.value,
            label: client.label,
          }));

          // Add the ' -- None --' option at the beginning
          clientOptions.unshift({ value: '', label: ' - None -' });
        
          setClientOptions(clientOptions);
        } catch (error) {
          console.error('Failed to fetch clients:', error);
        }
      }
    };

    fetchClients(transaction.divisionId);

  }, [transaction, divisionOptions, setValue])

  function isValidDateString(dateStr) {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  }

  useEffect(() => {
    console.log('✅ useEffect is running for transaction:', transaction?.id);
    console.log('📋 transaction.matchedItem:', transaction?.matchedItem);
    console.log('📋 transaction.matchedItem?.id:', transaction?.matchedItem?.id);

    if (transaction?.matchedItem?.id) {
      console.log('🎯 Setting plaidCreditCardTransactionId:', transaction.matchedItem.id);
      setValue('plaidCreditCardTransactionId', transaction.matchedItem.id);
    } else {
      console.log('⚠️ No matchedItem.id found:', transaction?.matchedItem);
    }

    if (transaction && iftaUnitOptions.length>0 && unitOptions.length>0) {

      if (transaction?.formattedTransactionDate) {
        handleDateChanged(transaction?.formattedTransactionDate);
      } else {
        setValue('transactionDate', '');
        setError('transactionDate', {
          type: 'preemptive',
          message: 'Transaction date is required'
        })
      }

      console.log('🔍 DEBUG - About to set plaidCreditCardTransactionId:', {
        matchedItemExists: !!transaction?.matchedItem,
        matchedItemId: transaction?.matchedItem?.id,
        shouldSetTo: transaction?.matchedItem?.id || ''
      });

      setValue('plaidCreditCardTransactionId', transaction.matchedItem?.id||'');

      setValue('capitalOneInstantNotificationId', transaction.capitalOneInstantNotificationId || null);
      
      const identityKey = transaction?.uploadedDocuments?.items[0]?.uploadedDocument?.identityId; // Extract the identity key
      setValue('identityKey', identityKey||'');

      const files = transaction?.uploadedDocuments?.items?.map((item) => {
        const key = item.uploadedDocument.key; // Extract the key
        const fileName = key.split('/').pop(); // Extract the file name from the key
        return { fileKey: key, fileName };
      });

      const filesParameter = JSON.stringify(files);
      // console.log('filesParameter: ', filesParameter);
      setValue('uploadedDocumentsJSON', filesParameter||'');

      setValue('merchantName', transaction?.matchedItem?.merchantEntityName||'UNKNOWN');
      setValue('newVendorName', '');
      // console.log('merchantName: ', transaction?.matchedItem?.merchantEntityName||'UNKNOWN');
      setValue('accountNumber', transaction?.matchedItem?.accountNumbe||'');
      // console.log('accountNumber: ', transaction?.matchedItem?.accountNumber);
      setValue('amount', transaction?.matchedItem?.amount||'');

      const rawAmount =
        transaction?.matchedItem?.amount ??
        transaction?.amountPaid ??
        transaction?.statementTotal ??
        '';

      const normalizedAmount = typeof rawAmount === 'number' ? rawAmount.toFixed(2) : rawAmount;

      setValue('amountPaid', normalizedAmount);

      // setValue('amountPaid', transaction?.matchedItem?.amount||transaction?.amountPaid||transaction?.statementTotal||'');
      // setValue('amountDue', transaction?.amountDue||transaction?.amountPaid||transaction?.statementTotal||'');
      // console.log('amount: ', transaction?.matchedItem?.amount);
      setValue('qbVendorId', transaction?.qbVendor?.qbId||'');
      // console.log('qbVendorId: ', transaction?.qbVendor?.qbId);

      // NEW: Check if vendor is marked as matched but qbVendor is null (the "(Vendor)" case)
      if (transaction?.qbSupplierMatched && !transaction?.qbVendor?.qbId && 
          transaction?.matchedItem?.merchantEntityName?.includes('(Vendor)')) {
        
        console.log('🔄 Vendor marked as matched but qbVendor is null, attempting to find vendor');
        
        // Extract vendor name without "(Vendor)"
        const vendorName = transaction.matchedItem.merchantEntityName.replace(' (Vendor)', '').trim();
        
        // Look up vendor in qbVendors array
        const matchedVendor = qbVendors?.find(v => 
          v.qbDisplayName === vendorName || 
          v.qbDisplayNameLower === vendorName.toLowerCase()
        );
        
        if (matchedVendor) {
          console.log('✅ Found vendor in qbVendors:', matchedVendor.qbId);
          
          // Update form values only - DO NOT mutate transaction prop
          setValue('qbVendorId', matchedVendor.qbId);
          setValue('merchantName', matchedVendor.qbDisplayName);
          
          // Note: We intentionally do NOT mutate transaction.qbVendor here
          // The form values are sufficient, and mutating props causes issues
          // when the modal is reopened
        } else {
          console.warn('⚠️ Vendor not found in qbVendors:', vendorName);
          // If vendor not found, mark as unmatched so user can select it
          setValue('qbSupplierMatched', false);
        }
      }

      setValue('transactionAmount', transaction?.matchedItem?.amount||'');
      setValue('addedNotes', transaction?.addedNotes||'');
      const tmId = transaction?.teamMemberId;
      const cardNumber = transaction?.matchedItem?.accountNumber;
      const tmIdCardNumber = `${tmId}#${cardNumber}`;
      setValue('tmIdCardNumber', tmIdCardNumber||'');
      setValue('qbSupplierMatched', transaction?.qbSupplierMatched||false);
      setValue('invoiceReceiptNumber', transaction?.invoiceReceiptID||'');
      setValue('iftaTeamMemberId', transaction?.teamMemberId||'');
      setValue('iftaFuelTaxTrackId', transaction?.iftaFuelTaxTrack?.id||'');

      if (transaction?.iftaFuelTaxTrack?.id) {
        setIftaGallons(transaction?.iftaFuelTaxTrack?.gallons||'');
        setValue('iftaGallons', transaction?.iftaFuelTaxTrack?.gallons);
        setIftaOdometer(transaction?.iftaFuelTaxTrack?.odometer||'');
        setValue('iftaOdometer', transaction?.iftaFuelTaxTrack?.odometer);
        if (transaction?.iftaFuelTaxTrack?.stateTwoChar) {
          const stateAbbrev = transaction?.iftaFuelTaxTrack?.stateTwoChar;
          const stateLabel = getStateOptions(stateAbbrev);
          setIftaState({ value: stateAbbrev, label: stateLabel });
          setValue('iftaState', { value: stateAbbrev, label: stateLabel });
        } else {
          setIftaState({ value: '', label: '-- Select State --' });
          setValue('iftaState', { value: '', label: '-- Select State --' });
        }

        // IFTA Unit
        if (transaction?.iftaFuelTaxTrack?.unitId) {
          const iftaUnit = iftaUnitOptions.find(
            unit => unit.value === transaction.iftaFuelTaxTrack.unitId
          );

          setValue('iftaUnitId', transaction.iftaFuelTaxTrack.unitId||'');

          setValue('selectOTRUnit', iftaUnit||'');
          clearErrors('selectOTRUnit');
          setSelectedIFTAUnitOption(iftaUnit || '');

        } else {
          setValue('selectOTRUnit', '');
          clearErrors('selectOTRUnit');
          setSelectedIFTAUnitOption('');
        }

        // expense category
        setValue('expenseCategoryLabel', selectedExpenseCategory?.label||'');
        setValue('iftaFuelTaxTrackId', transaction?.iftaFuelTaxTrack?.id||'');
      }

      if (selectedStatementType?.value === 'invoice') {

        if (transaction.vendorName.toLowerCase().includes("napa")) {
          // set the vendor to NAPA (Dallas Portal)
          // id: "1042"
          // name: "NAPA - Dallas (PORTAL)"

          handleMapVendorWrapper({id: "1042", name: "NAPA - Dallas (PORTAL)"}, 0)
          console.log('Setting invoice vendor to Napa Dallas Portal');
          
          const invoiceReceiptDate = transaction?.invoiceReceiptDate;
          if (isValidDateString(invoiceReceiptDate)) {
            const date = new Date(invoiceReceiptDate);
            date.setDate(date.getDate() + 20);
            const calculatedDueDate = date.toISOString().split("T")[0];
            console.log('invoiceReceiptDate: ', invoiceReceiptDate);
            console.log("Set due date:", calculatedDueDate);
            setValue('dueDate', calculatedDueDate||'');
            clearErrors('dueDate');
            setValue('transactionDate', invoiceReceiptDate||'');
            clearErrors('transactionDate');
          } else {
            console.error("Invalid date string:", invoiceReceiptDate);
          }
        }

        setValue('amountDue', transaction?.amountDue||transaction?.statementTotal||transaction?.amount||'');
        
      }
      
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction, setValue, iftaUnitOptions, unitOptions, qbVendors]);


  const handleIFTAUnitChange = (e) => {
    setSelectedIFTAUnitOption(e)
    setValue('selectOTRUnit', e.value)
    setValue('iftaUnitId', e.value)
    clearErrors('selectOTRUnit')
  };

  const updateSelectedState = (event) => {
    if (event.value==='') {
      setIftaState(event)
      setValue('iftaState', event)
      setError('iftaState', {
        type: 'preemptive',
        message: 'State is required'
      })
    } else {
      if (!event.label) {
        const stateSelected = stateOptions.find(state => state.value === event.value);
        event.label = stateSelected.label;
      }
      setIftaState(event)
      setValue('iftaState', event)
      clearErrors('iftaState')
    }
  }

  const updateIftaGallons = (event) => {
    // verify that the value is a number
    const isNumber = /^\d+$/.test(event.target.value);
    if (!isNumber) {
      return;
    }
    setIftaGallons(event.target.value);
    setValue('iftaGallons', event.target.value);
  }

  const updateIftaOdometer = (event) => {
    // verify that the value is a number
    const isNumber = /^\d+$/.test(event.target.value);
    if (!isNumber) {
      return;
    }
    setIftaOdometer(event.target.value);
    setValue('odometer', event.target.value);
  }

  const handleAmountDueChange = (amount) => {
    if (!amount) return ''
    
    if (Number(amount)) {
      const normalizedAmount = stripToNumbersAndDot(amount);
      console.log('normalizedAmount: ', normalizedAmount);
      const formattedAmount = Number(normalizedAmount).toFixed(2);
      console.log('formattedAmount: ', formattedAmount);
      setValue('amountDue', formattedAmount);
      clearErrors('amountDue');
    } else {
      setValue('amountDue', '');
      setError('amountDue', {
        type: 'preemptive',
        message: 'A valid amount is required'
      });
    } 
  }

  const handleInvoiceReceiptNumberChanged = (invoiceNumber) => {
    if (!invoiceNumber) return '';

    if (invoiceNumber?.length>0) {
      setValue('invoiceReceiptNumber', invoiceNumber);
      clearErrors('invoiceReceiptNumber');
    } else {
      setError('invoiceReceiptNumber', {
        type: 'preemptive',
        message: 'Invoice number is required'
      });
    }
    
    
  }

  const handleAmountPaidChange = (amount) => {
    console.log('AMOUNT: ', amount);
    // if (!amount) return ''
    if (amount === '' || amount == null) return '';

    const normalizedAmount = stripToNumbersAndDot(amount);
    const numericValue = Number(normalizedAmount);

    if (!isNaN(numericValue)) {
        const formattedAmount = numericValue.toFixed(2);
        setValue('amountPaid', formattedAmount);
        clearErrors('amountPaid');
    } else {
        setValue('amountPaid', '');
        setError('amountPaid', {
            type: 'preemptive',
            message: 'A valid amount is required'
        });
    }

  }

  return (
    <>
    {/* <Container as="form" maxW="1600" mb={12} onKeyDown={handleKeyDown} onSubmit={handleSubmit(updateReceipt)}> */}
    <Container as="form" maxW="1600" mb={12} noValidate onKeyDown={handleKeyDown} onSubmit={handleSubmit(async (data) => {
      setIsSubmitting(true);
      try {
        await updateReceipt(data);
      } finally {
        setIsSubmitting(false);
      }
    })}>
      <ModuleBoxDrawer>
        <Flex direction="column" maxW="1200px" mx="auto">
          <Flex>
            <Box>
              <Text as="span" textStyle='heading-1'>Receipt Approval</Text>
            </Box>
            <Spacer />
            <Box>
              <ButtonQuaternaryWithIcon 
                name='closeDrawer'
                iconsize='26px'
                leftIcon='close'
                value='Cancel'
                onClick={handleOnClose}
              />
            </Box>
          </Flex>

          <fieldset disabled={transaction.hasIssue && !issueIsResolved}>

            {/* Layout with Receipt Image and Form */}
            <Grid templateColumns="repeat(2, 1fr)" gap={12}>
              
              <GridItem>
                <Flex wrap="wrap" mt={4}>
                  {previewImages.map((preview, index) => {
                    // Extract file type from URL, handling query strings
                    const url = receiptSignedUrls[index] || '';
                    const urlWithoutQuery = url.split('?')[0]; // Remove query string
                    const fileType = urlWithoutQuery.split('.').pop()?.toLowerCase() || '';
                    console.log('fileType: ', fileType);
                    console.log('preview: ', preview);
                    return (
                      <Box key={index} m={2}>
                        {/* Conditionally handle image and PDF */}
                        {fileType === 'pdf' ? (
                          // PDF file: download when clicked
                          <a 
                            href={receiptSignedUrls[index]} 
                            download={`Receipt_${index + 1}`}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Image src={preview} alt={`PDF Preview ${index + 1}`} width="200px" cursor="pointer" />
                          </a>
                        ) : (
                          // Image file: open in modal when clicked
                          <Image
                            src={preview}
                            alt={`Image Preview ${index + 1}`}
                            // width="200px"
                            // width="400px"
                            maxW={'500px'}
                            cursor="pointer"
                            onClick={() => handleImageClick(receiptSignedUrls[index])}  // Open modal
                          />
                        )}
                      </Box>
                    );
                  })}
                </Flex>
              </GridItem>

              {/* Right Section: Form */}
              <GridItem w={'520px'}>
                <Stack spacing={6}>
                  <Box>
                    <Text as="span" textStyle='heading-3'>
                      Item Details
                    </Text>
                    <Stack spacing="5px" mt={'25px'}>
                      
                      {/* {transaction?.hasIssue && !issueIsResolved && <Text className='dark-sfpro-text-2' color='red'>Receipt has issue. {transaction?.issue}</Text>}
                      {issueIsResolved && <Text className='dark-sfpro-text-2' color='green'>Issue resolved. {transaction?.issue}</Text>} */}

                      

                      {/* <Text className='dark-sfpro-text-2'>Date: {spellOutDate(transaction?.matchedItem?.date, 'apple-ny')}</Text> */}
                      <Text className='dark-sfpro-text-2' color={(!assignedVendor && !transaction?.qbSupplierName) && 'red'}>QuickBooks Supplier: {assignedVendor ? assignedVendor.name : (transaction?.qbSupplierMatched) ? transaction?.qbSupplierName : (transaction?.qbSupplierName) ? `NEW ${transaction?.qbSupplierName}` : `N/A`} </Text>
                      <Text className='dark-sfpro-text-2'>Merchant: {transaction?.matchedItem?.merchantEntityName}</Text>

                      {/* transaction?.amountDue||transaction?.statementTotal||transaction?.amount||'' */}
                      {(transaction?.transactionType === 'receipt' || transaction?.transactionType === 'credit') ? <>
                        <Text className='dark-sfpro-text-2' color={(!transaction?.matchedItem?.amount && !transaction?.amount && !transaction?.amountPaid && !transaction?.statementTotal) && 'red'}>Amount: {formatCurrency(transaction?.matchedItem?.amount)}</Text>
                      </> : <>
                        {/* <Text className='dark-sfpro-text-2' >Amount: {formatCurrency(transaction?.matchedItem?.amount)}</Text> */}
                      </>}
                      
                      <Text className='dark-sfpro-text-2'>Notes: {transaction?.addedNotes}</Text>
                      {(transaction?.transactionType === 'receipt' || transaction?.transactionType === 'credit') ? <>
                        <Text className='dark-sfpro-text-2'>Card Number: {transaction?.matchedItem?.accountNumber}</Text>
                        <Text className='dark-sfpro-text-2'>Card Holder: {teamMemberName}</Text>
                      </> : <>
                        <Text className='dark-sfpro-text-2'>Card Holder: {teamMemberName}</Text>
                      </>}
                      
                      {(unitsAttached?.length>0) && <Text className='dark-sfpro-text-2'>Units: {unitsAttached.map((unit, index) => (
                        <Box key={index} paddingLeft={'25px'}>
                          {unit.unitName}
                        </Box>
                      ))}</Text>}
                      {selectedExpenseCategory?.isIFTATracked && <>
                        {(transaction?.iftaFuelTaxTrack?.iftaUnit) && <Text className='dark-sfpro-text-2'>IFTA Unit: {transaction?.iftaFuelTaxTrack?.iftaUnit}</Text>}
                        <Text className='dark-sfpro-text-2'></Text>
                      </>}
                      

                      {/* {expenseCategoryLocked && <>
                        <Text className='dark-sfpro-text-2'>Expense Category is locked due to IFTA tracking. Any changes to Expense Category will need to be made by the card holder.</Text>
                      </>} */}

                      {/* {divisionIsLocked && <>
                        <Text className='dark-sfpro-text-2'>Division is locked due to client being selected. Any changes to Division will need to be made by the card holder.</Text>
                      </>} */}

                      {selectedExpenseCategory?.isIFTATracked && <>

                        {/* IFTA Unit */}
                        <Box mt={'25px'} w={'60%'}>
                          <FormSelectSimple
                            register={register}
                            control={control}
                            errors={errors}
                            isRequired={true}
                            rules={{ required: "OTR Unit is required" }}
                            onChange={(e) => handleIFTAUnitChange(e)}
                            selectedoption={selectedIFTAUnitOption}
                            optionsArray={iftaUnitOptions}
                            fieldname="selectOTRUnit"
                            placeholder={'Select OTR unit'}
                            fieldlabel="OTR Unit"
                            issearchable={false}
                          />
                        </Box>

                        <Box mt={'25px'} w={'60%'}>
                          <FormSelectSimple
                            register={register}
                            control={control}
                            errors={errors}
                            isRequired={true}
                            rules={{ required: "State is required" }}
                            onChange={e => updateSelectedState(e)}
                            selectedoption={iftaState || null}
                            optionsArray={stateOptions}
                            fieldname='iftaState'
                            prettyname='State'
                            fieldlabel="State"
                            placeholder={'Select state'}
                          />
                        </Box>
                        
                        <Box mt={'25px'} w={'60%'}>
                          <TextInput
                            register={register}
                            errors={errors}
                            fieldname="iftaGallons"
                            fieldlabel="Gallons"
                            prettyname="Gallons"
                            placeholder="Enter gallons purchased"
                            fieldvalue={iftaGallons}
                            onChange={updateIftaGallons}
                            isRequired={true}
                            fieldtype='text'
                          />
                        </Box>

                        <Box mt={'25px'} w={'60%'}>
                          <TextInput
                            register={register}
                            errors={errors}
                            fieldname="iftaOdometer"
                            fieldlabel="Odometer"
                            prettyname="Odometer"
                            placeholder="Enter odometer miles"
                            fieldvalue={iftaOdometer}
                            onChange={updateIftaOdometer}
                            isRequired={true}
                            fieldtype='text'
                          />
                        </Box>

                      </>}

                      <Box mt={'25px'} w={'60%'}>
                        <FormSelectSimple
                          register={register}
                          control={control}
                          errors={errors}
                          isRequired={true}
                          rules={{ required: "Statement Type is required" }}
                          onChange={e => updateSelectedStatementType(e)}
                          selectedoption={selectedStatementType||''}
                          optionsArray={statementTypeOptions}
                          fieldname='selectStatementType'
                          prettyname='Type'
                          fieldlabel="Type"
                          placeholder={'Select type'}
                          issearchable={false}
                        />
                      </Box>
                      
                      <Box mt={'25px'} w={'60%'}>
                        <TextInput
                          register={register}
                          errors={errors}
                          fieldname="transactionDate"
                          fieldlabel="Purchase Date"
                          prettyname="Purchase Date"
                          onChange={event => setEnteredPurchaseDate(event.target.value)}
                          isRequired={true} 
                          fieldtype='date'
                        />
                      </Box>

                      {selectedStatementType?.value === 'receipt' && <Box mt={'25px'} w={'60%'}>
                        <TextInput
                          register={register}
                          errors={errors}
                          fieldname="amountPaid"
                          fieldlabel="Amount Paid"
                          prettyname="Amount Paid"
                          placeholder={'Enter amount paid'}
                          onBlur={event => handleAmountPaidChange(event.target.value)}
                          isRequired={true}
                          fieldtype='text'
                        />
                      </Box>}

                      {/* {(selectedStatementType?.value === 'invoice' || selectedStatementType?.value === 'receipt') && <> */}
                      {/* Handle for times when the vendor is new. qbSupplierName: 'New Vendor Name' && qbSupplierMatched: false 
                      transaction?.qbSupplierName?.length > 0
                      Oklahoma Corporation Commision
                      */}
                      {/* {(transaction?.qbSupplierMatched !== true && !transaction?.qbSupplierName) && ( */}
                      {/* {(transaction?.qbSupplierMatched !== true) && ( */}
                      {/* Confirmation shown once a vendor is assigned, in place of
                          the search box, so the admin gets clear feedback that the
                          selection took and will be used at publish. */}
                      {!shouldShowVendorMap && assignedVendor && (
                        <Box mt={2} mb={3} p={3} bg="green.50" border="1px solid" borderColor="green.200" borderRadius="md">
                          <Text className='dark-sfpro-text-2' color="green.700" fontWeight="bold">
                            ✓ QuickBooks Supplier set: {assignedVendor.name}
                          </Text>
                          <Text className='dark-sfpro-text-2' color="green.800" fontSize="sm" mt={1}>
                            This vendor will be used when this receipt is published to QuickBooks.
                          </Text>
                          <Box mt={2}>
                            <ButtonSecondaryPlain
                              type='button'
                              width={'180px'}
                              name='change-supplier'
                              value='Change supplier'
                              onClick={() => setShouldShowVendorMap(true)}
                            />
                          </Box>
                        </Box>
                      )}

                      {shouldShowVendorMap && (
                        <>
                          {(showEditSupplier === true || !!transaction?.merchantEntityName) && (
                            <Box>
                              <VendorMap
                                handleMapVendor={handleMapVendorWrapper}
                                vendorName={transaction?.matchedItem?.merchantEntityName}
                                vendors={qbVendors}
                                control={control}
                                register={register}
                                errors={errors}
                                setError={setError}
                                clearErrors={clearErrors}
                                setValue={setValue}
                                rowIndex={rowIndex}
                                showCreateSupplier={false}
                                handleNewVendorName={handleNewVendorName}
                                handleUpdateMerchant={handleUpdateMerchant}
                              />
                              <TextInput
                                fieldname="merchantName"
                                fieldvalue={updatedMerchantName||transaction?.qbSupplierName}
                                register={register}
                                errors={errors}
                                isRequired={true}
                                prettyname="QuickBooks Supplier"
                                // isReadOnly={true}
                                // fieldlabel="Updated QuickBooks Supplier"
                                fieldtype="hidden"
                              />
                            </Box>
                          )}
                        </>
                      )}

                      {selectedStatementType?.value === 'invoice' && (
                        <>
                          <Box mt="25px" w="60%">
                            <TextInput
                              register={register}
                              errors={errors}
                              fieldname="invoiceReceiptNumber"
                              fieldlabel="Invoice Number"
                              prettyname="Invoice Number"
                              placeholder="Enter invoice number"
                              onBlur={(event) => handleInvoiceReceiptNumberChanged(event.target.value)}
                              isRequired={true}
                              fieldtype="text"
                            />
                          </Box>

                          <Box mt="25px" w="60%">
                            <TextInput
                              register={register}
                              errors={errors}
                              fieldname="amountDue"
                              fieldlabel="Amount Due"
                              prettyname="Amount Due"
                              placeholder="Enter amount due"
                              onBlur={(event) => handleAmountDueChange(event.target.value)}
                              isRequired={true}
                              fieldtype="text"
                            />
                          </Box>

                          <Box mt="25px" w="60%">
                            <TextInput
                              register={register}
                              errors={errors}
                              fieldname="dueDate"
                              fieldlabel="Due Date"
                              prettyname="Due Date"
                              onBlur={(event) => setEnteredDueDate(event.target.value)}
                              isRequired={true}
                              fieldtype="date"
                            />
                          </Box>
                        </>
                      )}
                    
                      <Box mt={'25px'} w={'60%'}>
                        <FormSelectSimple
                          register={register}
                          control={control}
                          errors={errors}
                          isRequired={true}
                          // rules={{ required: "Expense Category is required" }}
                          onChange={e => {
                            console.log('e: ', e);
                            updateExpenseCategory(e, rowIndex);
                          }}
                          selectedoption={selectedExpenseCategory||''}
                          optionsArray={expenseCategories}
                          fieldname='selectExpenseCategory'
                          prettyname='Expense Category'
                          fieldlabel="Expense Category"
                          placeholder={'Select expense category'}
                          issearchable={true}
                          // isDisabled={expenseCategoryLocked}
                        />
                      </Box>

                      <Box mt={'25px'} w={'60%'}>
                        <FormSelectSimple
                          key='Division'
                          register={register}
                          control={control}
                          errors={errors}
                          isRequired={true}
                          rules={{ required: "Division is required" }}
                          fieldname="selectDivision"
                          fieldlabel="Division"
                          placeholder={'Select division'}
                          optionsArray={divisionOptions?.map((division, index) => ({
                            key: index,
                            value: division.value,
                            label: division.label
                          }))}
                          onChange={handleDivisionChange}
                          selectedoption={selectedDivision||''}
                          issearchable={false}
                          // isDisabled={divisionIsLocked}
                        />
                      </Box>

                      <Box mt={'25px'} w={'60%'}>
                        <FormSelectSimple
                          key='Client'
                          register={register}
                          control={control}
                          errors={errors}
                          // isRequired={true}
                          fieldname="selectClient"
                          fieldlabel="Client"
                          placeholder={'Select client'}
                          optionsArray={clientOptions}
                          onChange={handleClientChange}
                          selectedoption={selectedClient||''}
                          issearchable={false}
                        />
                      </Box>

                      {transaction?.hasIssue && <Box paddingTop={'25px'} >
                        {/* <Text as="span" textStyle="label-2" display="block" mt="4px" marginRight={'10px'}>Reason for return: </Text> */}
                        <Text
                          // paddingLeft="25px"
                          as="span"
                          textStyle="label-2"
                          display="block"
                          mt="4px"
                        >
                          {transaction?.issue.split('::cr::').map((line, index) => (
                            <Box key={index}>
                              {line}
                              {index < transaction?.issue.split('::cr::').length - 1 && <br />}
                            </Box>
                          ))}
                        </Text>
                      </Box>}
                    
                      <Box mt={'25px'} w={'100%'}>
                        <ButtonSecondaryPlain
                          type='button'
                          width={'245px'}
                          name='issue'
                          value='Issue with this receipt'
                          onClick={() => {
                            handleReceiptHasIssue();
                          }}
                        />                        
                      </Box>

                      <Divider my={'25px'} />

                      {!showHasIssueForm && (
                        <Flex gap="25px" align="center">
                         
                          <Box>
                            <ButtonSecondaryPlain
                              type="button"
                              width="245px"
                              name="detach-receipt"
                              value="Detach Receipt"
                              isDisabled={showHasIssueForm || isSubmitting}
                              onClick={() =>
                                handleDetachReceipt(
                                  transaction?.matchedItem?.id || transaction?.plaidCreditCardTransactionId,
                                  transaction?.id
                                )
                              }
                            />
                          </Box>

                           <Box>
                            <ButtonPrimaryPlain
                              type="submit"
                              width="245px"
                              name="publish-edited"
                              value={isSubmitting ? 'Publishing...' : 'Publish'}
                              isDisabled={showHasIssueForm || isSubmitting}
                            />
                          </Box>

                        </Flex>
                      )}

                      {showHasIssueForm && <Box mt={'25px'} bg={'var(--dark-menu-background)'}>
                        <Box w={'90%'} pl={'25px'} pt={'25px'}>
                          <TextareaInput
                            fieldname="receiptIssue"
                            prettyname="Receipt Issue"
                            register={register}
                            errors={errors}
                            placeholder="Enter receipt issue"
                            isRequired={true}
                            isReadOnly={false}
                            rows={2}
                            onChange={(e) => {
                              handleUpdateReceiptIssue(e.target.value);
                            }}
                          />
                        </Box>
                        <Box my={'25px'} w="100%" display="flex" justifyContent="center" alignItems="center">
                          <ButtonSecondaryPlain
                            width="245px"
                            type="button"
                            name="issue"
                            value="Return receipt to card holder"
                            onClick={() => {
                              handleReturnReceiptToCardholder();
                            }}
                          />
                        </Box>
                      </Box>}
                      
                    </Stack>
                  </Box>


                </Stack>
              </GridItem>
            </Grid>
          </fieldset>
        </Flex>
        <TextInput
          fieldname="plaidCreditCardTransactionId"
          fieldtype="hidden"
          register={register}
          errors={errors}
        />

        <TextInput
          fieldname="capitalOneInstantNotificationId"
          fieldtype="hidden"
          register={register}
          errors={errors}
        />
      </ModuleBoxDrawer>
    </Container>

    {/* Modal to show the image */}
    <Modal isOpen={isModalOpen} onClose={onModalClose} size={'full'}>
      <ModalOverlay />
      <ModalContent bg="black" position="relative">  {/* Set the background color to black */}
        
        {/* Custom close button */}
        <Box position="absolute" top="25px" right="25px">
          <ButtonQuaternaryWithIcon 
            name='closeModal'
            iconsize='26px'
            leftIcon='close'
            value='Close'
            onClick={onModalClose}
          />
        </Box>
        
        <ModalBody p="25px" pt="50px">  {/* Reduced top padding */}
          <Box bg="black" p="25px" borderRadius="md" mt="50px"> {/* Added margin-top to push image further down */}
            {currentImage && (
              <Image src={currentImage} alt="Receipt Image" width="100%" />
            )}
          </Box>
        </ModalBody>
      </ModalContent>
      </Modal>
      
    </>
  )
}

EditTransaction.propTypes = {
  transaction: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  environment: PropTypes.string.isRequired,
  expenseCategories: PropTypes.array.isRequired,
  selectedExpenseCategory: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  qbVendors: PropTypes.array.isRequired,
  handleMapVendor: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  updateExpenseCategory: PropTypes.func.isRequired,
  rowIndex: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  updateReceipt: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  adminName: PropTypes.string,
  handleDetachReceipt: PropTypes.func,
  onDocumentsFetched: PropTypes.func,
}